<!-- Job Controls -->
<div class="material-theme-login" [class.job-controls-hidden]="isJobControlsHidden">
  <module-container [customStyle]="{ 'margin-top': 0, padding: '0.8vw' }">
    <div class="controller-container">
      <div *ngIf="currentInputDocument === undefined">
        <button mat-raised-button color="accent" (click)="getNextFile()" [disabled]="isloading">
          Start Job
        </button>
      </div>
      <div class="job-title-container">
        <span>Statement Header & Line Item Job</span>
      </div>
    </div>
  </module-container>
</div>

<!-- Generic Confirmation Dialog -->
<div class="confirmation-overlay" *ngIf="showConfirmation" (click)="confirmationConfig.showCancel ? cancelConfirmation() : null">
  <div class="confirmation-dialog" (click)="$event.stopPropagation()">
    <h3>{{ confirmationConfig.title }}</h3>
    <p>{{ confirmationConfig.message }}</p>
    <div class="confirmation-actions">
      <button mat-button *ngIf="confirmationConfig.showCancel" (click)="cancelConfirmation()">Cancel</button>
      <button
        mat-raised-button
        [color]="confirmationConfig.confirmColor"
        (click)="executeConfirmation()"
      >
        {{ confirmationConfig.confirmText }}
      </button>
    </div>
  </div>
</div>

<!-- Main H&L Job Content -->
<div class="main-container" pFocusTrap>
  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isloading && currentInputDocument">
    <div class="loading-content">
      <mat-spinner diameter="50"></mat-spinner>
      <span>Processing...</span>
    </div>
  </div>

  <!-- Document Header data Section -->
  <div
    class="header-form-section"
    *ngIf="currentInputDocument !== undefined"
    [class.blur]="isloading"
  >
    <div class="form-fields-grid">
      <div class="p-field help-field">
        <label>&nbsp;</label>
        <button
          mat-stroked-button
          (click)="toggleHelp()"
          class="help-button"
          tabindex="-1"
          matTooltip="Help Overview (F1)"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
      <div class="p-field">
        <label for="supplierName">Supplier</label>
        <input
          id="supplierName"
          type="text"
          pInputText
          [value]="supplierName"
          readonly
          tabindex="-1"
        />
      </div>

      <div class="p-field ocr-field">
        <label for="documentTotal">Document Total</label>
        <p-inputNumber
          inputId="documentTotal"
          mode="decimal"
          step="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [(ngModel)]="documentTotal"
          (ngModelChange)="validateStatementAmountTotal()"
          [pAutoFocus]="true"
          (onFocus)="onInputFocus($event)"
          class="select-on-focus"
        />
      </div>
      <div
        class="channel-control-section"
        *ngIf="currentInputDocument !== undefined"
        [class.blur]="isloading"
      >
      <div class="p-field channel-field">
        <label for="channelSelect">Extract from</label>
        <p-dropdown
          inputId="channelSelect"
          [options]="availableChannels"
          [(ngModel)]="selectedChannel"
          (ngModelChange)="onChannelSelect($event)"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Channel"
          [disabled]="isChannelLoading || !currentInputDocument"
          [loading]="isChannelLoading"
          styleClass="channel-dropdown"
          appendTo="body"
          tabindex="-1"
        >
        </p-dropdown>
      </div>
    </div>
    </div>
  </div>
  <!-- Document PDF view and line item section -->
  <div class="job-container" *ngIf="currentInputDocument !== undefined" [class.blur]="isloading">
    <button
      mat-mini-fab
      (click)="expandPdfPanel()"
      color="primary"
      class="expand-pdf-btn"
      *ngIf="currentPanelSizes[0] <= 1"
      matTooltip="Show PDF Viewer"
      tabindex="-1"
    >
      <mat-icon>receipt_long</mat-icon>
    </button>
    <button
      mat-mini-fab
      (click)="expandTablePanel()"
      color="primary"
      class="expand-table-btn"
      *ngIf="currentPanelSizes[1] <= 1"
      matTooltip="Show line item table"
      tabindex="-1"
    >
      <mat-icon>table_view</mat-icon>
    </button>

    <p-splitter
      [panelSizes]="currentPanelSizes"
      [style]="{ height: '100%' }"
      (onResizeEnd)="onSplitterResizeEnd($event)"
    >
      <ng-template pTemplate="pdf-panel">
        <div class="pdf-panel-wrapper">
          <div
            class="pdf-pip-placeholder"
            *ngIf="isPdfInPopoutWindow"
            [style.minHeight.px]="pdfPanelPlaceholderHeight || 320"
          >
            <div class="placeholder-content">
              <div class="placeholder-title">PDF viewer is open in another window.</div>
              <div class="placeholder-subtitle">
                Close the pop-out window to bring it back here.
              </div>
            </div>
          </div>
          <div class="pdf-container" #pdfPanelContainer>
            <app-pdfjs-viewer
              #pdfViewer
              [pdfUrl]="pdfUrl"
              [config]="pdfViewerConfig"
              [autoLoad]="true"
              (onTextExtracted)="onTextExtracted($event)"
              (onGridExtracted)="onGridExtracted($event)"
              (onPdfOpenNewWindow)="onPdfOpenNewWindow()"
              (onPdfMinimized)="onPdfMinimized()"
            ></app-pdfjs-viewer>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="line-item-table-panel">
        <div class="table-container" *ngIf="!showGridExtractionPanel">
          <div class="table-content">
            <p-table
              #lineItemTable
              [class.skip-line-items]="supplierSkipLineItems"
              [columns]="displayedColumns"
              [value]="lineItems"
              dataKey="id"
              [scrollable]="true"
              scrollHeight="flex"
              [globalFilterFields]="[
                'documentDate',
                'documentType',
                'documentNumber',
                'amount'
              ]"
              (onEditComplete)="onEditComplete($event)"
            >
              <ng-template pTemplate="caption">
                <div class="table-controls-container">
                  <div class="column-chooser">
                    <p-multiSelect
                      [options]="allColumns"
                      [(ngModel)]="displayedColumns"
                      (onChange)="onSelectedColumnsChange()"
                      optionLabel="header"
                      placeholder="&nbsp;"
                      [displaySelectedLabel]="false"
                      [showHeader]="false"
                      styleClass="column-multiselect"
                      tabindex="-1"
                    >
                      <ng-template pTemplate="dropdownicon">
                        <i class="pi pi-bars"></i>
                      </ng-template>
                    </p-multiSelect>
                    <p-select
                      [options]="columnPresets"
                      [(ngModel)]="selectedPreset"
                      optionLabel="name"
                      (onChange)="onPresetChange($event)"
                      placeholder="Preset"
                      styleClass="preset-select"
                      tabindex="-1"
                    />
                    <span class="table-search">
                      <input
                        pInputText
                        class="p-inputtext-sm"
                        type="text"
                        (input)="lineItemTable.filterGlobal($event.target.value, 'contains')"
                        placeholder="Filter by keyword"
                        tabindex="-1"
                      />
                    </span>
                  </div>
                  <div class="actions-and-search">
                    <div class="table-action-buttons">
                      <p-button
                        icon="pi pi-arrows-h"
                        [rounded]="true"
                        [outlined]="true"
                        size="small"
                        (click)="openColumnSwapDialog()"
                        tabindex="-1"
                        pTooltip="Select and swap columns"
                        severity="info"
                      />
                      <span class="table-action-divider" aria-hidden="true"></span>
                      <p-button
                        icon="pi pi-arrow-up"
                        [rounded]="true"
                        [outlined]="true"
                        size="small"
                        (click)="addLineItemAtTop()"
                        tabindex="-1"
                        pTooltip="Add row to top"
                      />
                      <p-button
                        icon="pi pi-arrow-down"
                        [rounded]="true"
                        [outlined]="true"
                        size="small"
                        (click)="addLineItemAtBottom()"
                        tabindex="-1"
                        pTooltip="Add row to bottom"
                      />
                      <span class="table-action-divider" aria-hidden="true"></span>
                      <p-button
                        icon="pi pi-eraser"
                        [rounded]="true"
                        [outlined]="true"
                        size="small"
                        (click)="openClearColumnDialog()"
                        tabindex="-1"
                        pTooltip="Clear Column Data"
                        styleClass="clear-column-button"
                        severity="info"
                      />
                      <span class="table-action-divider" aria-hidden="true"></span>
                      <p-button
                        icon="pi pi-trash"
                        [rounded]="true"
                        [outlined]="true"
                        size="small"
                        severity="danger"
                        (click)="deleteAllRows()"
                        tabindex="-1"
                        pTooltip="clear all rows"
                      />
                    </div>
                  </div>
                  <div
                    class="confirmation-overlay"
                    *ngIf="showColumnSwapDialog"
                    (click)="cancelColumnSwap()"
                  >
                    <div class="confirmation-dialog swap-dialog" (click)="$event.stopPropagation()">
                      <h3>Swap Column Values</h3>
                      <p>Select two columns to swap their values across all rows:</p>

                      <div class="swap-selectors">
                        <div class="p-field">
                          <label for="swapColumn1">First Column</label>
                          <p-dropdown
                            inputId="swapColumn1"
                            [options]="swapColumnOptions"
                            [(ngModel)]="swapColumn1"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select first column"
                            styleClass="swap-dropdown"
                          />
                        </div>

                        <div class="swap-arrow">
                          <i class="pi pi-arrows-h"></i>
                        </div>

                        <div class="p-field">
                          <label for="swapColumn2">Second Column</label>
                          <p-dropdown
                            inputId="swapColumn2"
                            [options]="swapColumnOptions"
                            [(ngModel)]="swapColumn2"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select second column"
                            styleClass="swap-dropdown"
                          />
                        </div>
                      </div>

                      <div class="confirmation-actions">
                        <button mat-button (click)="cancelColumnSwap()">Cancel</button>
                        <button
                          mat-raised-button
                          color="primary"
                          (click)="executeColumnSwap()"
                          [disabled]="
                            !swapColumn1 ||
                            !swapColumn2 ||
                            swapColumn1 === swapColumn2 ||
                            !areColumnsCompatible()
                          "
                        >
                          Swap Columns
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="confirmation-overlay"
                    *ngIf="showClearColumnDialog"
                    (click)="cancelClearColumn()"
                  >
                    <div class="confirmation-dialog swap-dialog" (click)="$event.stopPropagation()">
                      <h3>Clear Column Data</h3>
                      <p>Select a column to clear its values for all line items:</p>

                      <div class="p-field clear-column-field">
                        <label for="clearColumnSelect">Column</label>
                        <p-dropdown
                          inputId="clearColumnSelect"
                          [options]="clearColumnOptions"
                          [(ngModel)]="selectedClearColumn"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select column"
                          styleClass="swap-dropdown clear-dropdown"
                        />
                      </div>

                      <div class="confirmation-actions">
                        <button mat-button (click)="cancelClearColumn()">Cancel</button>
                        <button
                          mat-raised-button
                          color="warn"
                          (click)="executeClearColumn()"
                          [disabled]="!selectedClearColumn"
                        >
                          Clear Column
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th
                    *ngFor="let col of displayedColumns"
                    [ngStyle]="col.style"
                    [ngClass]="col.class"
                  >
                    {{ col.header }}
                  </th>
                  <th class="actions-header">Actions</th>
                </tr>
              </ng-template>

              <ng-template
                pTemplate="body"
              let-lineItem
              let-columns="columns"
              let-rowIndex="rowIndex"
            >
              <tr
                class="line-item-row"
                [ngClass]="{ 'incomplete-row': isLineItemIncomplete(lineItem) }"
              >
                <td
                  *ngFor="let col of columns; let colIndex = index"
                  [pEditableColumn]="lineItem"
                    pEditableColumnField="{{ col.field }}"
                    [ngStyle]="col.style"
                    [ngClass]="col.class"
                    [attr.tabindex]="rowIndex === 0 && colIndex === 0 ? 0 : -1"
                    (focus)="onCellFocus(rowIndex, colIndex, $event)"
                  >
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input
                          *ngIf="col.type === 'string'"
                          pInputText
                          type="text"
                          [(ngModel)]="lineItem[col.field]"
                          (keydown)="onCellKeyDown($event)"
                          (focus)="onLineItemInputFocus(rowIndex, col.field, $event)"
                          class="select-on-focus"
                        />
                        <p-inputNumber
                          *ngIf="col.type === 'integer'"
                          step="0"
                          [(ngModel)]="lineItem[col.field]"
                          (onKeyDown)="onCellKeyDown($event)"
                          (focus)="onLineItemInputFocus(rowIndex, col.field, $event)"
                          class="select-on-focus"
                        />
                        <p-inputNumber
                          *ngIf="col.type === 'decimal'"
                          mode="decimal"
                          step="0"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                          [(ngModel)]="lineItem[col.field]"
                          (onInput)="onNumberInput($event, col.field)"
                          (onKeyDown)="onCellKeyDown($event)"
                          class="select-on-focus"
                          (onFocus)="onLineItemInputFocus(rowIndex, col.field, $event)"
                        />
                        <p-checkbox
                          *ngIf="col.type === 'boolean'"
                          [(ngModel)]="lineItem[col.field]"
                          [binary]="true"
                          (onKeyDown)="onCellKeyDown($event)"
                          (onFocus)="onLineItemInputFocus(rowIndex, col.field, $event)"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="col.type === 'string' || col.type === 'integer'">
                          {{ lineItem[col.field] }}
                        </ng-container>
                        <ng-container *ngIf="col.type === 'decimal'">
                          {{ lineItem[col.field] | number: '1.2-2' }}
                        </ng-container>
                        <ng-container>
                          <p-checkbox
                            *ngIf="col.type === 'boolean'"
                            [(ngModel)]="lineItem[col.field]"
                            [binary]="true"
                          />
                        </ng-container>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="actions-cell">
                    <div class="action-buttons">
                      <button
                        mat-icon-button
                        class="insert-btn"
                        (click)="insertRowAfter(rowIndex)"
                        tabindex="-1"
                      >
                        <mat-icon>add</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        class="delete-btn"
                        (click)="deleteRow(rowIndex)"
                        tabindex="-1"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="displayedColCount" class="empty-message">
                    <div class="empty-state">
                      <mat-icon>inbox</mat-icon>
                      <h3>No line items found</h3>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="skip-overlay" *ngIf="supplierSkipLineItems">
              <mat-icon>info</mat-icon>
              <span>Supplier configured to skip line items</span>
            </div>

            <!-- Totals and validation section -->
            <div class="totals-validation-section compact" *ngIf="lineItems.length > 0">
              <div
                id="statement-total-row"
                class="totals-row"
                [class.valid]="statementAmountTotalValid"
                [class.invalid]="!statementAmountTotalValid"
                *ngIf="statementAmountTotal != 0"
              >
                <div class="equation-left">
                  <div>{{ statementAmountTotal | currency }} (Amount Sum)</div>
                </div>
                <div class="equation-right">
                  <div class="equation-status">
                    <div *ngIf="statementAmountTotalValid">=</div>
                    <div *ngIf="!statementAmountTotalValid">≠</div>
                    <div>{{ documentTotal | currency }}</div>
                    <div class="validation-icon" *ngIf="statementAmountTotalValid">✓</div>
                    <div class="validation-icon invalid" *ngIf="!statementAmountTotalValid">✗</div>
                  </div>
                  <div class="variance-info" *ngIf="!statementAmountTotalValid">
                    Variance: {{ statementAmountVariance | currency }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Section -->
            <div class="submit-section compact">
              <div class="submit-info">
                <span class="submit-count">{{ lineItems.length }} items</span>
              </div>

              <!-- Action Buttons Container -->
              <div class="line-item-action-buttons">
                <p-button
                  icon="pi pi-trash"
                  label="Discard"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="onDiscardClick()"
                  [disabled]="isloading"
                  styleClass="action-btn discard-btn"
                  tabindex="-1"
                />
                <p-button
                  icon="pi pi-refresh"
                  label="Rescan"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="onRescanClick()"
                  [disabled]="isloading"
                  styleClass="action-btn rescan-btn"
                  tabindex="-1"
                />
                <p-button
                  icon="pi pi-undo"
                  label="Category"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="onCategoryClick()"
                  [disabled]="isloading"
                  styleClass="action-btn"
                  [pTooltip]="'Send to Category Job'"
                  tabindex="-1"
                />
                <p-button
                  icon="pi pi-user-edit"
                  label="Eze Manual"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="onEzeManualClick()"
                  [disabled]="isloading"
                  styleClass="action-btn"
                  [pTooltip]="'Send to Ezescan Manual'"
                  tabindex="-1"
                />
              </div>
              <div class="action-buttons-group">
                <p-button
                  icon="pi pi-stop"
                  label="Stop"
                  severity="danger"
                  [outlined]="true"
                  size="small"
                  (click)="confirmStopJob()"
                  [disabled]="isloading"
                  styleClass="action-btn"
                  [pTooltip]="'Stop Job'"
                  tabindex="-1"
                />
                <p-button
                  icon="pi pi-check"
                  label="Submit"
                  [severity]="
                    supplierSkipLineItems || statementAmountTotalValid
                      ? 'success'
                      : 'warning'
                  "
                  size="small"
                  (click)="onSubmitClick()"
                  [disabled]="isloading || (!supplierSkipLineItems && lineItems.length === 0)"
                  [styleClass]="
                    'action-btn submit-button ' +
                    (supplierSkipLineItems || statementAmountTotalValid
                      ? 'validation-valid'
                      : 'validation-warning')
                  "
                  [pTooltip]="
                    supplierSkipLineItems
                      ? 'Submit skips line items (Ctrl+Enter)'
                      : lineItems.length === 0
                        ? 'No line items to submit (Ctrl+Enter)'
                        : statementAmountTotalValid
                          ? 'Submit all line items (Ctrl+Enter)'
                          : 'Submit with validation errors (Ctrl+Enter)'
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Grid Extraction Panel (shown when showGridExtractionPanel = true) -->
        <div class="grid-extraction-container" *ngIf="showGridExtractionPanel">
          <app-grid-extraction-panel
            [gridData]="gridExtractionPanelData"
            [lineItemColumns]="lineItemColumns"
            [pageKey]="gridExtractionPanelPageKey"
            (cellClick)="onGridCellClick($event)"
            (rowIgnoreChange)="onGridRowIgnoreChange($event)"
            (importData)="onGridImportData($event)"
          ></app-grid-extraction-panel>
        </div>
      </ng-template>
    </p-splitter>
  </div>
</div>
